var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inputs" }, [
    _c("div", { staticClass: "input input-container" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("settings.tiwitterActionForm")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.clone.path,
            expression: "clone.path",
          },
        ],
        attrs: {
          placeholder: _vm.$t("settings.urlPlaceholderTwitter"),
          "no-flags": "",
        },
        domProps: { value: _vm.clone.path },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clone, "path", $event.target.value)
            },
            _vm.handleTiwitterUpdate,
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }